import { customElement } from 'lit/decorators.js'

import { OxGristEditorValueRanges } from '@operato/grist-editor/ox-grist-editor-value-ranges.js'

@customElement('color-ranges-editor')
export class ColorRangesEditor extends OxGristEditorValueRanges {
  get options() {
    const overidable = this.column.record?.options || {}

    return {
      name: `Color Ranges : ${this.record.name}`,
      valuetype: 'color',
      objectified: true,
      ...overidable
    }
  }
}
